import {
  LayoutDashboard,
  Landmark,
  ArrowDownCircle,
  ArrowUpCircle,
  Sparkles,
  PiggyBank,
  Flame,
  Coins,
  Building2,
  Database,
  Shuffle,
  Repeat,
  Vault,
  ClipboardCheck,
  GitCompareArrows,
  Waves,
  BookOpen,
  Users,
  Inbox,
  BookOpenCheck,
  CloudDownload,
  Users2,
  FileSpreadsheet,
} from "lucide-react";

export const NAV_GROUPS = [
  {
    label: "Control Room",
    items: [
      { to: "/", label: "P&L Dashboard", icon: LayoutDashboard, end: true, id: "dashboard" },
      { to: "/inbox", label: "Exception Inbox", icon: Inbox, id: "inbox" },
      { to: "/day-close", label: "Day-End Control", icon: ClipboardCheck, id: "day-close" },
      { to: "/mis", label: "MIS & AI Insights", icon: Sparkles, id: "mis" },
    ],
  },
  {
    label: "Books · Double Entry",
    items: [
      { to: "/recon", label: "Bank Reconciliation", icon: GitCompareArrows, id: "recon" },
      { to: "/journal", label: "General Ledger", icon: BookOpen, id: "journal" },
      { to: "/income", label: "Income", icon: Coins, id: "income" },
      { to: "/expenses", label: "Expenses", icon: Flame, id: "expenses" },
      { to: "/payroll", label: "Payroll", icon: Users2, id: "payroll" },
    ],
  },
  {
    label: "Cash & Banking",
    items: [
      { to: "/banks", label: "Bank Balances", icon: Landmark, id: "banks" },
      { to: "/cashflow", label: "Cashflow", icon: Waves, id: "cashflow" },
      { to: "/transfers", label: "Internal Transfers", icon: Shuffle, id: "transfers" },
      { to: "/sweeps", label: "Sweep & FD", icon: Repeat, id: "sweeps" },
    ],
  },
  {
    label: "Payables & Receivables",
    items: [
      { to: "/payables", label: "Vendors Payable", icon: ArrowUpCircle, id: "payables" },
      { to: "/receivables", label: "ARR Receivable", icon: ArrowDownCircle, id: "receivables" },
      { to: "/vendors", label: "Vendors", icon: Building2, id: "vendors" },
      { to: "/debtors", label: "Debtors", icon: Users, id: "debtors" },
      { to: "/invoice-inbox", label: "Invoice Inbox", icon: CloudDownload, id: "invoice-inbox" },
      { to: "/invoice-recon", label: "Invoice Reconciliation", icon: FileSpreadsheet, id: "invoice-recon" },
    ],
  },
  {
    label: "Assets & Investments",
    items: [
      { to: "/fixed-deposits", label: "Fixed Deposits", icon: Vault, id: "fixed-deposits" },
      { to: "/fixed-assets", label: "Fixed Assets", icon: Building2, id: "fixed-assets" },
      { to: "/investments", label: "Investments & FIRC", icon: PiggyBank, id: "investments" },
    ],
  },
  {
    label: "Workspace",
    items: [
      { to: "/sop", label: "How to use (SOP)", icon: BookOpenCheck, id: "sop" },
      { to: "/backup", label: "Backup & Reset", icon: Database, id: "backup" },
    ],
  },
];
